import type { SeriesVisibility } from '~/pages/BalanceDemand/constants'

export { CURRENT_KOMA, GC_KOMA } from '~/constants/koma'

export const BASE_SCALES: Record<string, number> = {
  hokkaido: 1800,
  tohoku: 2800,
  tokyo: 3500,
  chubu: 2500,
  hokuriku: 900,
  kansai: 3000,
  chugoku: 1500,
  shikoku: 800,
  kyushu: 2200,
}

const DEMAND_GROUP_OPTIONS = [
  'all',
  'grp_industrial',
  'grp_commercial',
  'grp_residential',
] as const
export type DemandGroupFilter = (typeof DEMAND_GROUP_OPTIONS)[number]

export function isDemandGroupFilter(value: string): value is DemandGroupFilter {
  return (DEMAND_GROUP_OPTIONS as readonly string[]).includes(value)
}

// 電圧階級は絞り込みフィルターから撤去した (issue #4734)。 データ量を絞る他 3 つ
// (小売 / 需要グループ / 料金プラン) と性質が違うものが同じ行に並び、「電圧階級別」
// トグルより上位概念に見えていたため。 内訳の表示制御は系列トグルに一本化する。
export type DetailFilterState = {
  bgCode: string
  /** 小売フィルターの選択 (4 桁事業者コード)。'' = BG 全体。 */
  retailerCode: string
  demandGroup: DemandGroupFilter
  ratePlan: string
  /** チャート系列トグル (design bg-region 基本表示/電圧階級別/分析補助/詳細。
   *  キーは一覧 BalanceDemand の SeriesKey と同一)。 */
  series: SeriesVisibility
  /** 電圧階級別 親チェックボックス (OFF で配下 3 階級をまとめて無効化)。 */
  voltageEnabled: boolean
  /** 分析補助 親チェックボックス (OFF で配下 3 系列をまとめて無効化)。 */
  analysisEnabled: boolean
  /** 詳細 親チェックボックス (OFF で配下 2 系列をまとめて無効化)。 */
  detailEnabled: boolean
}

export const DEFAULT_DETAIL_FILTER: DetailFilterState = {
  bgCode: '',
  retailerCode: '',
  demandGroup: 'all',
  ratePlan: 'all',
  // spec: 親子とも全デフォルト ON (一覧の DEFAULT_SERIES_VISIBILITY とは既定が異なる)。
  series: {
    demandPlan: true,
    demandActual: true,
    weather: true,
    temperature: true,
    precipitation: true,
    procurementNet: true,
    demandActualCorrected: true,
    voltageExtraHigh: true,
    voltageHigh: true,
    voltageLow: true,
    dewPoint: true,
  },
  voltageEnabled: true,
  analysisEnabled: true,
  detailEnabled: true,
}
